import type * as React from 'react';

import type { CustomizationContentLink, CustomizationHeaderItem } from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import { Button, DialogRoot, DialogTrigger } from '@gitbook/spine-react';

import type { ItemType } from './LinkDialog';
import { EditLinkDialog } from './LinkDialog';

export function EditLinkButton(props: {
    item: CustomizationContentLink | CustomizationHeaderItem;
    itemType: ItemType;
    onChange: React.ComponentProps<typeof EditLinkDialog>['onChange'];
    siteSpaceIds: string[];
}) {
    const { item, itemType, onChange, siteSpaceIds } = props;
    return (
        <DialogRoot>
            <DialogTrigger>
                <Button iconOnly kind="blank" size="small" leadingIcon={Icon.Edit} label="Edit" />
            </DialogTrigger>
            <EditLinkDialog
                title={`Edit ${item.title}`}
                item={item}
                onChange={onChange}
                itemType={itemType}
                siteSpaceIds={siteSpaceIds}
            />
        </DialogRoot>
    );
}
